<cosmos-table
  [columns]="_columns"
  [dataSource]="_dataSource"
  [isFilterable]="false"
  [isPaginable]="false"
></cosmos-table>
